import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '@shared/ui/badges'
import type { BadgeAttendanceReasonProps } from './interfaces'

import { useListsStore } from '@shared/model'
import { useBadgeFromStatus } from '@shared/ui/badges'

import { TutorAttendanceRateReason } from '../../model/enums'

interface BadgeAttendanceReasonOptions {
  props: BadgeAttendanceReasonProps
}

interface BadgeAttendanceReasonReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

/** The legacy markers: green for a completed lesson, red for cancellations, amber for reschedules and no-shows. */
const ATTENDANCE_REASON_COLORS: Record<TutorAttendanceRateReason, AppBadgeColor> = {
  [TutorAttendanceRateReason.Completed]: 'emerald',
  [TutorAttendanceRateReason.Canceled]: 'red',
  [TutorAttendanceRateReason.Canceled1stLesson]: 'red',
  [TutorAttendanceRateReason.CanceledBad]: 'red',
  [TutorAttendanceRateReason.CanceledBad1stLesson]: 'red',
  [TutorAttendanceRateReason.Rescheduled]: 'amber',
  [TutorAttendanceRateReason.RescheduledBad]: 'amber',
  [TutorAttendanceRateReason.TutorNoShow]: 'amber',
  [TutorAttendanceRateReason.TutorNoShow1stLesson]: 'amber',
}

export const useBadgeAttendanceReason = ({ props }: BadgeAttendanceReasonOptions): BadgeAttendanceReasonReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<TutorAttendanceRateReason>({
    status: () => props.reason,
    colors: ATTENDANCE_REASON_COLORS,
    labels: () => listsStore.getLists?.tutor_attendance_rate?.reason,
  })
}
